// UX15/UX34: client fetcher for the daily-generated server snapshots.
//
// The GitHub-Actions-run snapshot_job.py writes bots/snapshots.json
// (full per-poll history, 40+ MB) and bots/daily_meta.json (poll of
// the day). agora's build step runs scripts/prepare-snapshots.js
// which combines them into a wrapper and writes it to
// public/snapshots.json so Vercel serves it at /snapshots.json.
//
// Wrapper shape:
//   { poll_of_the_day: "<pollId>" | "", polls: { "<pollId>": { bill_actions: [...] } } }
//
// This module fetches once per page load and caches the promise.
// On any failure (missing file, 404 in dev before `npm run
// snapshots:copy`, malformed JSON) the cache resolves to an empty
// wrapper and subsequent calls return instantly — the client falls
// back to the empty billActions default and skips the hero card
// without further network traffic.

const SNAPSHOTS_URL = '/snapshots.json'
const EMPTY = { pollOfTheDay: '', pollOfTheDayKind: '', billOfTheMoment: '', polls: {} }

let cachePromise = null

export function loadServerSnapshots() {
  if (cachePromise) return cachePromise
  cachePromise = (async () => {
    try {
      const resp = await fetch(SNAPSHOTS_URL, { cache: 'no-cache' })
      if (!resp.ok) return EMPTY
      const raw = await resp.json()
      if (!raw || typeof raw !== 'object') return EMPTY
      return {
        pollOfTheDay:
          typeof raw.poll_of_the_day === 'string' ? raw.poll_of_the_day : '',
        // UX57: 'pulse' when the slot holds today's pulse question,
        // 'bill' when it holds a legislative fallback (no pulse ran).
        // Client uses this to pick the right badge.
        pollOfTheDayKind:
          raw.poll_of_the_day_kind === 'pulse' || raw.poll_of_the_day_kind === 'bill'
            ? raw.poll_of_the_day_kind
            : '',
        // UX57: second hero slot for the high-score legislative pick.
        // Empty string on days the legislative scorer didn't cross the
        // POTD_BILL_FLOOR in snapshot_job.py; Home.jsx then renders
        // only the pulse hero.
        billOfTheMoment:
          typeof raw.bill_of_the_moment === 'string' ? raw.bill_of_the_moment : '',
        polls:
          raw.polls && typeof raw.polls === 'object' ? raw.polls : {},
      }
    } catch {
      return EMPTY
    }
  })()
  return cachePromise
}

export function resetServerSnapshotsCache() {
  cachePromise = null
}
